<template>
  <div class="changeSuccess">
    <h1 class="title">账号安全设置</h1>
    <div class="complete">
      <div>
        <p style="margin:0;">
          <img src="../../assets/complete2.png">
        </p>
        <p class="friendly-tips">新密码设置成功</p>
        <!-- <p style="font-size:16px;color:#333333;margin-bottom:45px;">当前你的密码安全性低，就差一步就可以完成密码修改！</p> -->
      </div>
      <el-button type="primary" @click="backLogin">返回登录</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  created () {
    if (sessionStorage.step !== 'passChecked') {
      this.$router.push('/')
    }
  },
  mounted () {
  },
  methods: {
    backLogin () {
      sessionStorage.clear()
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss">
.changeSuccess {
  width: 1020px;
  margin: 0 auto;
  background: rgb(255, 255, 255);
  .title {
    font-weight: normal;
    font-size: 24px;
    margin: 30px 40px;
    color: #333333;
    border-bottom:1px solid #eeeeee;
    padding-bottom: 20px;
  }
  .complete {
    text-align: center;
    img {
      margin: 50px 0 30px 0;
    }

    .el-button {
      margin-top: 90px;
      background-color: #1060ab;
    }

    .friendly-tips {
      margin-left: 10px;
      font-size: 24px;
      margin: 0;
      margin-bottom: 20px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/findPass/changeDone.vue